import { render, staticRenderFns } from "./currencyChart.vue?vue&type=template&id=651f54a4&scoped=true"
import script from "./currencyChart.vue?vue&type=script&lang=js"
export * from "./currencyChart.vue?vue&type=script&lang=js"
import style0 from "./currencyChart.vue?vue&type=style&index=0&id=651f54a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f54a4",
  null
  
)

export default component.exports